"use client";

import { useContext } from "react";
import { RouterContext } from "../provider/router-provider";

export const useRouter = () => {
    const context = useContext(RouterContext);
    if (!context) {
        throw Error("useRouter must be used within a RouterProvider");
    }
    return context;
};
